import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import {auth} from '../firebase'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
   {
    path: '/links',
    name: 'Links',
    component: () => import('../views/LinksView.vue')
  },
  {
    path: '/tattoo',
    name: 'Tattoo',
    component: () => import('../views/TattooView.vue'),
    meta: { requiresAuth:true }
  },
  {
    path: '/cardio',
    name: 'Cardio',
    component: () => import('../views/CardioView.vue'),
    meta: { requiresAuth:true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  const isLoggedIn = !!auth.currentUser

  // Route protégée et pas connecté → accueil
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next('/')
    return
  }

  next()
})

export default router
